// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

// models, types
import { CallToActionType, CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { Partner } from '@/interfaces/Partner';
import { GET_INTEGRATED_RETAILER } from '@/store/types';

// components
import AmazonFresh from './components/amazon-fresh/AmazonFresh.vue';
import Basketful from './components/basketful/Basketful.vue';
import CustomLink from './components/custom-link/CustomLink.vue';
import Email from './components/email/Email.vue';
import Instacart from './components/instacart/Instacart.vue';
import Kroger from './components/kroger/Kroger.vue';
import Walmart from './components/walmart/Walmart.vue';

@Component({
    components: {
        AmazonFresh,
        Basketful,
        CustomLink,
        Email,
        Instacart,
        Kroger,
        Walmart,
    },
})
export default class CallToAction extends Vue {
    @Getter(GET_INTEGRATED_RETAILER) getIntegratedRetailer!: string;

    @Prop() ctaType!: string;

    @Prop() label!: string;

    @Prop() url!: string;

    @Prop() subject!: string;

    @Prop() body!: string;

    @Prop() partner!: string;

    @Prop() showCheckoutTotal!: boolean;

    @Prop({ required: true }) position!: CallToActionPosition;

    get useStatic(): boolean {
        return this.ctaType === CallToActionType.STATIC;
    }

    get useEmail(): boolean {
        return this.ctaType === CallToActionType.EMAIL;
    }

    get useAmazonFresh(): boolean {
        return this.ctaType === CallToActionType.PARTNER && this.partner === Partner.AMAZON_FRESH;
    }

    get useBasketful(): boolean {
        return this.ctaType === CallToActionType.PARTNER && this.partner === Partner.BASKETFUL;
    }

    get useInstacart(): boolean {
        return this.ctaType === CallToActionType.PARTNER && this.partner === Partner.INSTACART;
    }

    get useWalmart(): boolean {
        return this.ctaType === CallToActionType.RETAILER_CART && this.getIntegratedRetailer === Partner.WALMART;
    }

    get useKroger(): boolean {
        return this.ctaType === CallToActionType.RETAILER_CART && this.getIntegratedRetailer === Partner.KROGER;
    }
}
